// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { Badge } from "@/components/ui/badge";
// // import { Sheet, SheetContent, SheetTrigger, SheetHeader, SheetTitle } from "@/components/ui/sheet";
// import {
//   Sheet,
//   SheetContent,
//   SheetHeader,
//   SheetTitle,
//   SheetTrigger,
// } from "@/components/ui/sheet";

// import { createPageUrl } from "@/utils";
// import { base44 } from "@/api/base44Client"; 
// import { useAuth } from "@/auth/AuthContext"; 
// import { useQuery, useQueryClient } from "@tanstack/react-query";
// import { getTranslation } from "@/components/utils/translations";

// import {
//   Home, Search, ShoppingCart, Bell, Menu, X, Package, Truck, Tag, Star,
//   AlertTriangle, Sparkles, Wrench, ClipboardList, Trash2, RotateCcw,
//   Building2, Grid3X3, ChevronLeft, LogOut, FileText, Users, Wallet, Settings
// } from "lucide-react";

// import { Button } from "@/components/ui/button";
// // import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

// export default function Layout({ children, currentPageName }) {
//   const queryClient = useQueryClient();
//   const { user: currentUser, logout } = useAuth(); 

//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [categoriesOpen, setCategoriesOpen] = useState(false);

//   const [language, setLanguage] = useState("he");

//   const t = (key) => getTranslation(language, key);

//   const roleKey = currentUser?.role?.key || currentUser?.role;
//   const isSuperAdminUser = currentUser?.isSuperAdmin === true || roleKey === 'SUPER_ADMIN' || roleKey === 'admin';
//   const isSystemAdmin = isSuperAdminUser || roleKey === 'SYSTEM_ADMIN' || currentUser?.custom_role === 'system_admin';
//   const isStoreManager = roleKey === 'SUPER_MANAGER' || currentUser?.custom_role === 'store_manager';
//   const isAreaManager = roleKey === 'AREA_MANAGER' || currentUser?.custom_role === 'area_manager';


//   const { data: notifications = [] } = useQuery({
//     queryKey: ['notifications'],
//     queryFn: async () => {
//         try {
//             return await base44.entities.Notification.list();
//         } catch (e) { return []; }
//     },
//     enabled: !!currentUser, // רק אם מחובר
//     refetchInterval: 30000, // רענון כל 30 שניות
//   });

//   // חישוב מספר ההודעות שלא נקראו
//   const unreadCount = notifications.filter(n => !n.is_read).length;
//   const { data: userStore } = useQuery({
//     queryKey: ['myStore', currentUser?.store_id],
//     queryFn: async () => {
//         // טיפול במקרה ש-store_id הוא אובייקט (populated) או מחרוזת
//         const storeId = typeof currentUser?.store_id === 'object' ? currentUser.store_id._id : currentUser?.store_id;
//         if (!storeId) return null;
//         try {
//             return await base44.entities.Store.get(storeId);
//         } catch (e) { return null; }
//     },
//     enabled: !!currentUser?.store_id && !isSystemAdmin 
//   });

//   const { data: userChain } = useQuery({
//     queryKey: ['myChain', userStore?.chain_id],
//     queryFn: async () => {
//         const chainId = typeof userStore?.chain_id === 'object' ? userStore.chain_id._id : userStore?.chain_id;
//         if (!chainId) return null;
        
//         try {
//             const chains = await base44.entities.Chain.list(); 
//             return chains.find(c => (c.id || c._id) === chainId);
//         } catch (e) { return null; }
//     },
//     enabled: !!userStore,
//     staleTime: 1000 * 60 * 30 
//   });

//   const getMenuItems = () => {
//     return [
//       { name: t("home"), page: "Home", icon: Home },
//       { name: t("storeProducts"), page: "StoreProducts", icon: Package },
//       { name: t("productSearch"), page: "ProductSearch", icon: Search },
//       { name: t("categories"), page: "Categories", icon: Grid3X3 },
//       { name: t("companies"), page: "Companies", icon: Building2 },
//       { name: t("suppliers"), page: "Suppliers", icon: Truck },
//       { name: t("promotions"), page: "Promotions", icon: Tag },
//       { name: t("brochures"), page: "Brochures", icon: FileText },
//       { name: t("promotionImplementation"), page: "PromotionImplementation", icon: Tag },
//       { name: t("recommendations"), page: "Recommendations", icon: Star },
//       { name: t("mustOrder"), page: "MustOrder", icon: AlertTriangle },
//       { name: t("newProducts"), page: "NewProducts", icon: Sparkles },
//       { name: t("slowMovingProducts"), page: "SlowMovingProducts", icon: ClipboardList },
//       { name: t("orders"), page: "Orders", icon: Package },
//       { name: t("serviceRequests"), page: "ServiceRequests", icon: Wrench },
//       { name: t("inventoryCount"), page: "InventoryCount", icon: ClipboardList },
//       { name: t("safeCount"), page: "SafeCount", icon: Wallet },
//       { name: t("notifications"), page: "Notifications", icon: Bell },
//       { name: t("destructions"), page: "Destructions", icon: Trash2 },
//       { name: t("returns"), page: "Returns", icon: RotateCcw },
      
//     ];
//   };

//   const getMenuItemsForUser = () => {
//     let baseItems = [...getMenuItems()];

//     if (isSystemAdmin) {
//       baseItems = baseItems.filter(item => 
//         !["ProductSearch", "StoreProducts", "NewProducts", "InventoryCount", "SafeCount"].includes(item.page)
//       );
      
//       const items = [...baseItems];
//       items.splice(1, 0, { name: t("products"), page: "Products", icon: Package });

//       const promotionImplIndex = items.findIndex(item => item.page === "PromotionImplementation");
//       if (promotionImplIndex !== -1) {
//         items.splice(promotionImplIndex + 1, 0, { name: t("manageInventoryCounts"), page: "ManageInventoryCounts", icon: ClipboardList });
//       }

//       return [
//         ...items,
//         { name: t("chains"), page: "Chains", icon: Building2 },
//         { name: t("stores"), page: "Stores", icon: Building2 },
//         { name: t("safeCountAdmin"), page: "SafeCountAdmin", icon: Wallet },
//         { name: t("users"), page: "Users", icon: Users }, 
//         { name: "הגדרות מערכת", page: "SystemSettings", icon: Settings }
//       ];
//     }
    
//     if (isStoreManager) {
//       return [
//         ...baseItems,
//         { name: t("users"), page: "Users", icon: Users },
//       ];
//     }
    
//     if (isAreaManager) {
//       const allowedPages = ['Home', 'Returns', 'Destructions', 'ServiceRequests', 'Notifications', 'PromotionImplementation', 'ManageInventoryCounts'];
//       const areaItems = baseItems.filter(item => allowedPages.includes(item.page));
//       return [...areaItems, { name: t("users"), page: "Users", icon: Users }];
//     }

//     return baseItems; 
//   }; 

//   // const displayMenuItems = getMenuItemsForUser();

//   const MENU_ITEMS = getMenuItemsForUser(); // 👈 זה התיקון! היינו צריכים את הרשימה המלאה לפי תפקיד

//   const displayMenuItems = MENU_ITEMS.filter(item => {
//     // 1. בדיקת הרשאות מודולים
//     if (item.page === 'ServiceRequests') {
//        // גישה ישירה לאובייקט (אם קיים)
//        const access = currentUser?.modules_access?.service_requests;
       
//        // אם המשתמש לא סופר אדמין, והוגדר לו במפורש "none" -> הסתר
//        if (!currentUser?.isSuperAdmin && access === 'none') {
//            return false;
//        }
//     }

//     // 2. בדיקות תפקידים רגילות (הקוד הקיים)
//     if (item.roles && !item.roles.includes(roleKey)) return false;
//     if (item.excludeRoles && item.excludeRoles.includes(roleKey)) return false;
//     if (item.dataScope && item.dataScope !== dataScope) {
//         if (dataScope === 'GLOBAL') return true; 
//         return false;
//     }
//     return true;
//   });


//   const isMenuItemActive = (itemPage) => currentPageName === itemPage;
//   const mainCategories = []; 
//   const getSubCategories = () => []; 
//   // const unreadCount = 0; 

//   // רכיב לוגו לשימוש חוזר
//   const ChainLogoOrText = ({ className }) => {
//     if (userChain?.logo_url) {
//       return (
//         <div className={`flex items-center justify-center bg-white rounded-lg p-1 ${className}`}>
//            <img src={userChain.logo_url} alt={userChain.name} className="h-full w-auto object-contain" />
//         </div>
//       );
//     }
//     return (
//         <div className={`flex items-center justify-center bg-white/20 rounded-lg px-4 ${className}`}>
//             <span className="text-white font-bold text-lg">
//                 {isSystemAdmin ? t("systemAdmin") : isAreaManager ? t("areaManager") : "משתמש"}
//             </span>
//         </div>
//     );
//   };

//   // שליפת פריטי הסל עבור האייקון בהדר
//   const { data: cartItems = [] } = useQuery({
//     queryKey: ['cartItems', currentUser?.store_id],
//     queryFn: () => base44.entities.CartItem.list({ store_id: currentUser?.store_id }),
//     enabled: !!currentUser?.store_id && isStoreManager,
//   });

//   // חישוב כמות הפריטים הכוללת
//   const cartCount = cartItems.reduce((sum, item) => sum + (item.quantity || 0), 0);

//   return (
//     <div dir="rtl" className="min-h-screen bg-gray-50">
      
//       {/* Header */}
//       <header className="sticky top-0 z-50 bg-white border-b border-gray-100 shadow-sm">
//         <div className="flex items-center justify-between px-4 py-3">
//           <div className="flex items-center gap-3">
//             <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
//               <SheetTrigger asChild>
//                 <Button variant="ghost" size="icon" className="lg:hidden">
//                   <Menu className="w-6 h-6" />
//                 </Button>
//               </SheetTrigger>
//               <SheetContent side="right" className="w-80 p-0">
//                 <div className="flex flex-col h-full">
//                   <div className={`p-6 flex flex-col items-end ${isAreaManager ? 'bg-gradient-to-l from-slate-600 to-slate-700' : 'bg-gradient-to-l from-red-600 to-red-700'}`}>
                    
//                     {/* --- השינוי כאן: הצגת לוגו בתפריט צד --- */}
//                     <ChainLogoOrText className="h-16 mb-2 w-full bg-white/90" />
//                     {/* -------------------------------------- */}

//                     <p className="text-red-100 text-sm">
//                       {currentUser?.fullName || "שלום אורח"}
//                     </p>
//                   </div>
//                   <nav className="flex-1 overflow-y-auto py-4">
//                     {displayMenuItems.map((item) => (
//                       <Link
//                         key={item.page}
//                         to={createPageUrl(item.page)}
//                         onClick={() => setIsMenuOpen(false)}
//                         className={`flex items-center justify-end gap-3 px-6 py-3 transition-colors ${
//                           isMenuItemActive(item.page)
//                             ? "bg-red-50 text-red-700 border-r-4 border-red-600"
//                             : "text-gray-600 hover:bg-gray-50"
//                         }`}
//                       >
//                         <span className="font-medium">{item.name}</span>
//                         <item.icon className="w-5 h-5" />
//                       </Link>
//                     ))}
//                   </nav>
//                   <div className="p-4 border-t">
//                     <Button
//                       variant="ghost"
//                       className="w-full flex items-center justify-end gap-3 px-2 text-red-600 hover:bg-red-50"
//                       onClick={logout}
//                     >
//                       <span>{t("logout")}</span>
//                       <LogOut className="w-5 h-5" />
//                     </Button>
//                   </div>
//                 </div>
//               </SheetContent>
//             </Sheet>

//             <Link to={createPageUrl("Home")} className="flex items-center gap-2">
//                 {/* --- השינוי כאן: הצגת לוגו ב-Header הראשי --- */}
//                 {userChain?.logo_url && !isSystemAdmin ? (
//                     <div className="h-10 flex items-center justify-center bg-white border border-gray-100 rounded-lg px-2 shadow-sm">
//                         <img 
//                             src={userChain.logo_url} 
//                             alt={userChain.name} 
//                             className="h-8 w-auto object-contain" 
//                         />
//                     </div>
//                 ) : (
//                     <div className="h-10 flex items-center justify-center bg-red-100 rounded-lg px-3 gap-2">
//                         <span className="text-red-700 font-bold text-sm">
//                             {isSystemAdmin ? t("systemAdmin") : "Reshet"}
//                         </span>
//                         <Home className="w-4 h-4 text-red-700" />
//                     </div>
//                 )}
//             </Link>
//           </div>

//           <div className="flex items-center gap-0">
//   {/* חיפוש */}
//   <Link to={createPageUrl("ProductSearch")}>
//     <Button variant="ghost" size="icon">
//       <Search className="w-5 h-5 text-gray-600" />
//     </Button>
//   </Link>

//   {/* קטגוריות (Sheet) */}
//   <Sheet open={categoriesOpen} onOpenChange={setCategoriesOpen}>
//     <SheetTrigger asChild>
//       <Button variant="ghost" size="icon">
//         <Grid3X3 className="w-5 h-5 text-gray-600" />
//       </Button>
//     </SheetTrigger>
//     <SheetContent side="right" className="w-80 overflow-y-auto [&>button]:left-4 [&>button]:right-auto">
//       <SheetHeader>
//         <SheetTitle className="text-right">{t("allCategories")}</SheetTitle>
//       </SheetHeader>

//       <div className="mt-6 space-y-3">
//         {mainCategories.map((mainCat) => {
//           const subCats = getSubCategories(mainCat.id);
//           return (
//             <div key={mainCat.id} className="border rounded-lg overflow-hidden">
//               <Link
//                 to={createPageUrl(`CategoryProducts?id=${mainCat.id}`)}
//                 onClick={() => setCategoriesOpen(false)}
//               >
//                 <div className="bg-red-600 hover:bg-red-700 transition-colors p-3 flex items-center justify-between cursor-pointer">
//                   <ChevronLeft className="w-4 h-4 text-white" />
//                   <span className="font-bold text-white">{mainCat.name}</span>
//                 </div>
//               </Link>

//               {subCats.length > 0 && (
//                 <div className="p-2 bg-gray-50 space-y-1">
//                   {subCats.map((subCat) => (
//                     <Link
//                       key={subCat.id}
//                       to={createPageUrl(`CategoryProducts?id=${subCat.id}`)}
//                       onClick={() => setCategoriesOpen(false)}
//                     >
//                       <div className="px-3 py-2 text-sm hover:bg-red-50 rounded transition-colors cursor-pointer text-right">
//                         {subCat.name}
//                       </div>
//                     </Link>
//                   ))}
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </SheetContent>
//   </Sheet>

//   {/* התראות */}
//   <Link to={createPageUrl("Notifications")}>
//     <Button variant="ghost" size="icon" className="relative">
//       <Bell className="w-5 h-5 text-gray-600" />
//       {unreadCount > 0 && (
//         <Badge className="absolute -top-1 -right-1 w-5 h-5 p-0 flex items-center justify-center bg-red-500 text-white text-xs">
//           {unreadCount}
//         </Badge>
//       )}
//     </Button>
//   </Link>

//   {isStoreManager && (
//     <Link to={createPageUrl("Cart")}>
//       <Button variant="ghost" size="icon" className="relative">
//         <ShoppingCart className="w-5 h-5 text-gray-600" />
//         {cartCount > 0 && (
//           <Badge className="absolute -top-1 -right-1 w-5 h-5 p-0 flex items-center justify-center bg-red-600 text-white text-xs">
//             {cartCount}
//           </Badge>
//         )}
//       </Button>
//     </Link>
//   )}

//   {/* התנתקות */}
//   <Button variant="ghost" size="icon" onClick={logout} title={t("logout")}>
//     <LogOut className="w-5 h-5 text-red-500" />
//   </Button>
// </div>

//         </div>
//       </header>

//       {/* Desktop Sidebar */}
//       <div className="flex">
//         <aside className="hidden lg:flex flex-col w-64 h-[calc(100vh-65px)] bg-white border-r border-gray-100 sticky top-[65px]">
//           <nav className="flex-1 py-4 overflow-y-auto">
//             {displayMenuItems.map((item) => (
//               <Link
//                 key={item.page}
//                 to={createPageUrl(item.page)}
//                 className={`flex items-center justify-start gap-3 px-6 py-3 transition-colors ${
//                   isMenuItemActive(item.page)
//                     ? "bg-red-50 text-red-700 border-r-4 border-red-600"
//                     : "text-gray-600 hover:bg-gray-50"
//                 }`}
//               >
//                 <item.icon className="w-5 h-5" />
//                 <span className="font-medium">{item.name}</span>
//               </Link>
//             ))}
//           </nav>
//           <div className="p-4 border-t bg-white">
//             <Button
//               variant="ghost"
//               className="w-full flex items-center justify-start gap-3 px-2 text-red-600 hover:bg-red-50"
//               onClick={logout}
//             >
//               <LogOut className="w-5 h-5" />
//               <span>{t("logout")}</span>
//             </Button>
//           </div>
//         </aside>

//         <main className="flex-1 min-h-[calc(100vh-65px)] bg-gradient-to-br from-red-50 via-slate-50 to-slate-100">
//           {children}
//         </main>
//       </div>
//     </div>
//   );
// }




import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
// import { Sheet, SheetContent, SheetTrigger, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";

import { createPageUrl } from "@/utils";
import { base44 } from "@/api/base44Client"; 
import { useAuth } from "@/auth/AuthContext"; 
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getOfflineCart, setOfflineCart, syncOfflineCartToServer, normalizeStoreId } from "@/lib/offlineCart";
import { useCartItemsQuery } from "@/hooks/useCartItemsQuery";
import { useLocalStore } from "@/contexts/LocalStoreContext";
import { getTranslation } from "@/components/utils/translations";
import { motion } from "framer-motion";

import {
  Home, ShoppingCart, Bell, Menu, X, Package, Truck, Tag, Star,
  AlertTriangle, Sparkles, Wrench, ClipboardList, Trash2, RotateCcw,
  Building2, Grid3X3, ChevronLeft, LogOut, FileText, Users, Wallet, Settings,
  Filter, AlertCircle, LayoutGrid, ArrowDownAZ, Eye, ArrowRight,
} from "lucide-react";
import { writeAuthToken } from "@/lib/authStorage";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { useCategoryFilter } from "@/contexts/CategoryFilterContext";
import { asArray } from "@/lib/asArray";
import { getMenuUserLabel } from "@/lib/userDisplayName";
import { MatzahIcon } from "@/components/icons/MatzahIcon";
// import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

export default function Layout({ children, currentPageName }) {
  /** גובה סרגל העליון — fixed + spacer כדי שהסרגל (עגלה, התראות, תפריט) יישאר תמיד גלוי בגלילה */
  const layoutHeaderRef = useRef(null);
  const [appHeaderHeightPx, setAppHeaderHeightPx] = useState(64);

  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const location = useLocation();
  const { user: currentUser, logout } = useAuth();
  const cartAccess = currentUser?.isSuperAdmin 
    ? 'edit' 
    : (currentUser?.modules_access?.cart || 'none');

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [categoriesOpen, setCategoriesOpen] = useState(false);
  const [isCategoryFilterOpen, setIsCategoryFilterOpen] = useState(false);
  const categoryFilter = useCategoryFilter();
  const isCategoriesOrCategoryProducts =
    location.pathname === "/Categories" || location.pathname === "/CategoryProducts";
  const isCategoryProductsPage = location.pathname === "/CategoryProducts";

  const [language, setLanguage] = useState("he");

  const t = (key) => getTranslation(language, key);

  const roleKey = currentUser?.role?.key || currentUser?.role;
  const isMerlogManager = roleKey === 'MERLOG_MANAGER';
  const isPromotionsManager = roleKey === 'PROMOTIONS_ADMIN';
  const isAgent = roleKey === 'AGENT' || currentUser?.custom_role === 'AGENT';
  const isImpersonating = !!currentUser?.is_impersonating;

  // ── חזרה לסוכן — מחזירה את הטוקן+משתמש של הסוכן ────────────────────────
  const handleReturnToAgent = () => {
    const agentToken = localStorage.getItem("agent_backup_token");
    const agentUser  = localStorage.getItem("agent_backup_user");
    if (agentToken) {
      writeAuthToken(agentToken);
      if (agentUser) localStorage.setItem("app_user", agentUser);
      localStorage.removeItem("agent_backup_token");
      localStorage.removeItem("agent_backup_user");
    }
    window.location.href = "/AgentPanel";
  };
  // ─────────────────────────────────────────────────────────────────────────

  const isSuperAdminUser = currentUser?.isSuperAdmin === true || roleKey === 'SUPER_ADMIN' || roleKey === 'admin';
  const isSystemAdmin = isSuperAdminUser || roleKey === 'SYSTEM_ADMIN' || currentUser?.custom_role === 'system_admin' || isPromotionsManager || isMerlogManager;
  const isStoreManager =
    roleKey === "SUPER_MANAGER" ||
    roleKey === "STORE_MANAGER" ||
    currentUser?.custom_role === "store_manager";
  const isAreaManager = roleKey === 'AREA_MANAGER' || currentUser?.custom_role === 'area_manager';


  const { data: notifications = [] } = useQuery({
    queryKey: ['notifications'],
    queryFn: async () => {
        try {
            return await base44.entities.Notification.list();
        } catch (e) { return []; }
    },
    enabled: !!currentUser,
    staleTime: 60 * 1000,
    refetchInterval: 60000,
  });

  const notificationList = asArray(notifications);
  // חישוב מספר ההודעות שלא נקראו
  const unreadCount = notificationList.filter((n) => !n.is_read).length;
  const { data: userStore } = useQuery({
    queryKey: ['myStore', currentUser?.store_id],
    queryFn: async () => {
        const storeId = typeof currentUser?.store_id === 'object' ? currentUser.store_id._id : currentUser?.store_id;
        if (!storeId) return null;
        try {
            return await base44.entities.Store.get(storeId);
        } catch (e) { return null; }
    },
    enabled: !!currentUser?.store_id && !isSystemAdmin,
    staleTime: 5 * 60 * 1000,
  });

  const { data: userChain } = useQuery({
    queryKey: ['myChain', userStore?.chain_id],
    queryFn: async () => {
        const chainId = typeof userStore?.chain_id === 'object' ? userStore.chain_id._id : userStore?.chain_id;
        if (!chainId) return null;
        
        try {
            const chains = await base44.entities.Chain.list(); 
            return chains.find(c => (c.id || c._id) === chainId);
        } catch (e) { return null; }
    },
    enabled: !!userStore,
    staleTime: 1000 * 60 * 30 
  });

  const storeId = currentUser?.store_id?._id || currentUser?.store_id;
  const { localData: prefetched } = useLocalStore();

  const getMenuItems = () => {
    return [
      { name: t("home"), page: "Home", icon: Home },
      { name: t("storeProducts"), page: "StoreProducts", icon: Package },
      { name: t("categories"), page: "Categories", icon: Grid3X3 },
      { name: t("companies"), page: "Companies", icon: Building2 },
      { name: t("suppliers"), page: "Suppliers", icon: Truck },
      { name: t("promotions"), page: "Promotions", icon: Tag },
      { name: t("brochures"), page: "Brochures", icon: FileText },
      { name: t("promotionImplementation"), page: "PromotionImplementation", icon: Tag },
      { name: t("recommendations"), page: "Recommendations", icon: Star },
      { name: t("mustOrder"), page: "MustOrder", icon: AlertTriangle },
      { name: t("newProducts"), page: "NewProducts", icon: Sparkles },
      { name: t("slowMovingProducts"), page: "SlowMovingProducts", icon: ClipboardList },
      { name: t("orders"), page: "Orders", icon: Package },
      { name: t("serviceRequests"), page: "ServiceRequests", icon: Wrench },
      { name: t("inventoryCount"), page: "InventoryCount", icon: ClipboardList },
      { name: t("safeCount"), page: "SafeCount", icon: Wallet },
      { name: t("notifications"), page: "Notifications", icon: Bell },
      { name: t("destructions"), page: "Destructions", icon: Trash2 },
      { name: t("returns"), page: "Returns", icon: RotateCcw },
      { name: "משימות הנהלה", page: "StoreManagementTasks", icon: ClipboardList },
      
    ];
  };

  const getMenuItemsForUser = () => {
    let baseItems = [...getMenuItems()];

    if (isSystemAdmin) {
      baseItems = baseItems.filter(item => 
        !["StoreProducts", "NewProducts", "InventoryCount", "SafeCount"].includes(item.page)
      );
      
      const items = [...baseItems];
      items.splice(1, 0, { name: t("products"), page: "Products", icon: Package });

      const promotionImplIndex = items.findIndex(item => item.page === "PromotionImplementation");
      if (promotionImplIndex !== -1) {
        items.splice(promotionImplIndex + 1, 0, { name: t("manageInventoryCounts"), page: "ManageInventoryCounts", icon: ClipboardList });
      }

      return [
        ...items,
        { name: t("chains"), page: "Chains", icon: Building2 },
        { name: t("stores"), page: "Stores", icon: Building2 },
        { name: "משימות הנהלה", page: "ManagementTasks", icon: ClipboardList },
        { name: t("safeCountAdmin"), page: "SafeCountAdmin", icon: Wallet },
        { name: t("users"), page: "Users", icon: Users }, 
        { name: "הגדרות מערכת", page: "SystemSettings", icon: Settings }
      ];
    }
    
    if (isStoreManager) {
      return [
        ...baseItems,
        { name: t("users"), page: "Users", icon: Users },
      ];
    }
    
    if (isAreaManager) {
      const allowedPages = ['Home', 'Returns', 'Destructions', 'ServiceRequests', 'Notifications', 'PromotionImplementation', 'ManageInventoryCounts'];
      const areaItems = baseItems.filter(item => allowedPages.includes(item.page));
      return [...areaItems, { name: t("users"), page: "Users", icon: Users }];
    }

    if (roleKey === 'MERLOG_MANAGER') {
      return [
        { name: t("home"), page: "Home", icon: Home },
        { name: t("suppliers"), page: "Suppliers", icon: Truck },
        { name: t("orders"), page: "Orders", icon: Package },
        { name: t("stores"), page: "Stores", icon: Building2 } // 👈 הוספנו למרלוג
      ];
    }

    if (isAgent) {
      return [
        { name: "לוח הסוכן", page: "AgentPanel", icon: Users },
      ];
    }

    return baseItems; 
  }; 

  // const displayMenuItems = getMenuItemsForUser();

  const MENU_ITEMS = getMenuItemsForUser(); // 👈 זה התיקון! היינו צריכים את הרשימה המלאה לפי תפקיד

// Layout.jsx
const moduleMapping = {
  // דף הבית
  "Home": "home",

  // מוצרים
  "Products": "products_admin",
  "StoreProducts": "store_products",
  "ProductSearch": "product_search",
  "NewProducts": "new_products",
  
  // מלאי וספירות (הכפתור ששאלת עליו)
  "InventoryCount": "inventory_count",         // ספירה בסניף
  "ManageInventoryCounts": "inventory_manage", // ניהול ספירות (אדמין) 👈
  "SafeCount": "safe_count",
  "SafeCountAdmin": "safe_count",

  // ללא תנועה (הכפתור ששאלת עליו)
  "SlowMovingProducts": "slow_moving",         // בסניף 👈
  "AllSlowMovingProducts": "all_slow_moving",  // רשתי 👈

  // הזמנות ומבצעים
  "Recommendations": "recommendations",
  "MustOrder": "must_order",
  "Promotions": "promotions",
  "Brochures": "brochures",
  "PromotionImplementation": "promotion_impl",
  "Orders": "orders",

  // ניהול רשת
  "Chains": "chains",
  "Stores": "stores",
  "Suppliers": "suppliers",
  "Companies": "companies",
  "Categories": "categories",

  // מערכת
  "Notifications": "notifications",
  "ServiceRequests": "service_requests",
  "Destructions": "destructions",
  "Returns": "returns",
  "StoreManagementTasks": "tasks",
  "ManagementTasks": "tasks",
  "Users": "users",
  "SystemSettings": "system_settings",
  "Cart": "cart"
};
  // const displayMenuItems = MENU_ITEMS.filter(item => {
  //   // א. סופר אדמין רואה הכל
  //   if (currentUser?.isSuperAdmin) return true;

  //   if (roleKey === 'PROMOTIONS_ADMIN') {
  //     // מנהל מבצעים רואה רק את דף הבית ואת דף המבצעים
  //     return [ 'Promotions'].includes(item.page);
  // }    

  //   // ב. בדיקה אם המודול חסום (none)
  //   const moduleKey = moduleMapping[item.page];
  //   if (moduleKey) {
  //     const access = currentUser?.modules_access?.[moduleKey];
  //     if (access === 'none') return false; 
  //   }

  //   // ג. כאן נכנסת הלוגיקה המקורית שלך - אנחנו לא נוגעים בה!
  //   if (item.adminOnly) return isSuperAdmin;
  //   if (item.areaManagerOnly) return isAreaManager;
    
  //   return true;
  // });

 
  const displayMenuItems = MENU_ITEMS.filter(item => {
    // 1. סופר אדמין תמיד רואה הכל
    if (currentUser?.isSuperAdmin) return true;
  
    // 2. בדיקת הרשאות מודולים מה-DB
    const moduleKey = moduleMapping[item.page];
    if (moduleKey) {
      const access = currentUser?.modules_access?.[moduleKey];
      // מציגים רק אם הגישה היא 'view' או 'edit'. אם 'none' - מסתירים
      return access === 'view' || access === 'edit';
    }
  
    // 3. דפים שאין להם הרשאה ספציפית (כמו דף הבית) - יוצגו לכולם
    return true;
  });
 
  const isMenuItemActive = (itemPage) => currentPageName === itemPage;
  const mainCategories = []; 
  const getSubCategories = () => []; 
  // const unreadCount = 0; 

  // רכיב לוגו לשימוש חוזר – לוגו מהמקומי (prefetch) או מהשרת
  const chainForLogo = prefetched?.chain || userChain;
  const ChainLogoOrText = ({ className }) => {
    if (!currentUser) return <div className={`animate-pulse bg-gray-200 rounded-lg ${className}`} />;
    const isActualStoreManager = !!currentUser.store_id && !isSystemAdmin;
    const logoUrl = chainForLogo?.logo_data_url || chainForLogo?.logo_url;
    if (logoUrl && isActualStoreManager) {
      return (
        <div className={`flex items-center justify-center bg-white rounded-lg p-1 ${className}`}>
          <img src={logoUrl} alt={chainForLogo?.name || "רשת"} className="h-full w-auto object-contain" />
        </div>
      );
    }
    
    // 3. מנהלי מערכת/מרלוג: מציגים מיד את השם מה-Role
    return (
      <div className={`flex items-center justify-center bg-red-100 rounded-lg px-3 ${className}`}>
          <span className="text-red-700 font-bold text-sm text-center">
              {currentUser?.role?.name || "Reshet"}
          </span>
      </div>
    );
  };
  // סנכרון סל אופליין כשחוזר חיבור
  useEffect(() => {
    const sid = currentUser?.store_id?._id || currentUser?.store_id;
    if (!sid || !isStoreManager) return;
    const sync = () => {
      syncOfflineCartToServer(sid, {
        queryClient,
        updateCartItem: (payload) => base44.entities.CartItem.update(payload),
        fetchList: () => base44.entities.CartItem.list({ store_id: sid }),
      });
    };
    window.addEventListener("online", sync);
    return () => window.removeEventListener("online", sync);
  }, [currentUser?.store_id, isStoreManager, queryClient]);

  const { data: cartItems = [] } = useCartItemsQuery(storeId, {
    enabled: !!storeId && isStoreManager,
  });

  // טעינה מוקדמת של דפים נפוצים – מעבר בין דפים יהיה מהיר (גם בפעם הראשונה)
  React.useEffect(() => {
    if (!storeId) return;
    const t = setTimeout(() => {
      import("./Categories");
      import("./StoreProducts.jsx");
      import("./Companies");
      import("./CategoryProducts.jsx");
      import("./CompanyProducts");
      import("./Cart");
      import("./ProductSearch.jsx");
      import("./ProductDetails");
    }, 150);
    return () => clearTimeout(t);
  }, [storeId]);

  // זריעת סל מהשרת בכניסה ראשונית (רק כשיש רשת והסל המקומי ריק)
  React.useEffect(() => {
    const sid = normalizeStoreId(storeId);
    if (!sid || !navigator.onLine) return;
    if (getOfflineCart(sid).length > 0) return;
    base44.entities.CartItem.list({ store_id: sid })
      .then((list) => {
        const items = Array.isArray(list) ? list : (list?.data ?? []);
        if (items.length > 0) {
          setOfflineCart(sid, items);
          queryClient.invalidateQueries({ queryKey: ["cartItems", sid] });
        }
      })
      .catch(() => {});
  }, [storeId, queryClient]);

  // מספר המוצרים בעגלה:
  // כאן הכוונה היא למספר השורות/מוצרים שונים בסל (distinct products),
  // ולא סך היחידות (כמו 10 במבה = 1 בספירה).
  const cartCount = Array.isArray(cartItems) ? cartItems.length : 0;

  useLayoutEffect(() => {
    const el = layoutHeaderRef.current;
    const measure = () => {
      if (el?.offsetHeight) setAppHeaderHeightPx(el.offsetHeight);
    };
    measure();
    const ro = new ResizeObserver(measure);
    if (el) ro.observe(el);
    window.addEventListener("orientationchange", measure);
    return () => {
      ro.disconnect();
      window.removeEventListener("orientationchange", measure);
    };
  }, []);

  return (
    <div
      dir="rtl"
      className="h-screen flex flex-col overflow-hidden min-w-0 max-w-full bg-gray-50"
      style={{ "--app-header-height": `${appHeaderHeightPx}px` }}
    >

      {/* ── באנר התחזות — מופיע בראש המסך כשהסוכן נמצא בתצוגת חנות ─────────── */}
      {isImpersonating && (
        <div
          dir="rtl"
          className="fixed inset-x-0 top-0 z-[60] flex items-center justify-between px-4"
          style={{ height: "40px", background: "#b91c1c", boxShadow: "0 2px 6px rgba(0,0,0,0.18)" }}
        >
          {/* ימין: כפתור חזרה */}
          <button
            onClick={handleReturnToAgent}
            className="flex items-center gap-1.5 bg-white/15 hover:bg-white/25 active:scale-95 transition-all rounded-lg px-2.5 py-1 text-white text-xs font-semibold"
          >
            <ArrowRight className="w-3.5 h-3.5 flex-shrink-0" />
            חזרה לסוכן
          </button>

          {/* מרכז: שם החנות */}
          <div className="flex items-center gap-2 min-w-0">
            <span className="w-2 h-2 rounded-full bg-white/60 animate-pulse flex-shrink-0" />
            <span className="text-white/70 text-xs font-normal flex-shrink-0">מצב צפייה —</span>
            <span className="text-white text-xs font-bold truncate max-w-[140px]">
              {currentUser?.store_name || currentUser?.fullName || "חנות"}
            </span>
          </div>

          {/* שמאל: סגירה */}
          <button
            onClick={handleReturnToAgent}
            aria-label="סגור"
            className="flex items-center justify-center w-7 h-7 rounded-full text-white/60 hover:bg-white/15 hover:text-white active:scale-95 transition-all flex-shrink-0"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      )}
      {/* ─────────────────────────────────────────────────────────────────────── */}

      {/* Header — fixed כדי שיישאר תמיד למעלה (sticky נשבר בגלל overflow באבות) */}
      <header
        ref={layoutHeaderRef}
        className="fixed inset-x-0 z-50 border-b border-gray-100 bg-white shadow-sm pt-[env(safe-area-inset-top,0px)]"
        style={{ top: isImpersonating ? "40px" : "0px" }}
      >
        <div className="relative flex min-h-[60px] w-full items-center gap-2 px-4 py-2.5 sm:min-h-[64px]">
          <div className="flex items-center gap-3 shrink-0 z-10">
            <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="lg:hidden">
                  <Menu className="w-6 h-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-80 p-0" style={isImpersonating ? { paddingTop: "40px" } : {}}>
                <div className="flex flex-col h-full">
                  <div className={`px-6 pb-5 pt-6 flex flex-col items-center ${isAreaManager ? 'bg-gradient-to-l from-slate-600 to-slate-700' : 'bg-gradient-to-l from-red-600 to-red-700'}`}>

                    {/* לוגו קשת גיבורים על רקע לבן */}
                    <div className="w-full bg-white rounded-xl flex items-center justify-center py-3 px-4 mb-3 shadow-sm">
                      <img
                        src="/keshetLogo-removebg-preview.png"
                        alt="קשת גיבורים"
                        className="h-12 w-auto object-contain"
                      />
                    </div>

                    <p className="text-red-100 text-sm text-right w-full">
                      {getMenuUserLabel(currentUser)}
                    </p>
                  </div>
                  <nav className="flex-1 overflow-y-auto py-4">
                    {displayMenuItems.map((item) => {
                      const url = createPageUrl(item.page);
                      const isCurrentPage = location.pathname === url || location.pathname === url + "/";
                      return (
                        <Link
                          key={item.page}
                          to={url}
                          onClick={() => {
                            if (isCurrentPage) window.scrollTo({ top: 0, behavior: "smooth" });
                            setIsMenuOpen(false);
                          }}
                          className={`flex items-center justify-end gap-3 px-6 py-3 transition-colors ${
                            isMenuItemActive(item.page)
                              ? "bg-red-50 text-red-700 border-r-4 border-red-600"
                              : "text-gray-600 hover:bg-gray-50"
                          }`}
                        >
                          <span className="font-medium">{item.name}</span>
                          <item.icon className="w-5 h-5" />
                        </Link>
                      );
                    })}
                  </nav>
                  <div className="p-4 border-t">
                    <Button
                      variant="ghost"
                      className="w-full flex items-center justify-end gap-3 px-2 text-red-600 hover:bg-red-50"
                      onClick={logout}
                    >
                      <span>{t("logout")}</span>
                      <LogOut className="w-5 h-5" />
                    </Button>
                  </div>
                </div>
              </SheetContent>
            </Sheet>

            <Link to={createPageUrl("Home")} className="flex items-center gap-2">
    {/* אם הוא אדמין או מרלוג - נציג את שם התפקיד; מנהל סניף – לוגו הרשת מוסתר */}
    {isSystemAdmin ? (
        <div className="h-10 flex items-center justify-center bg-red-100 rounded-lg px-3 gap-2">
            <span className="text-red-700 font-bold text-sm">
            {currentUser?.role?.name || "מנהל מערכת"}
            </span>
            <Home className="w-4 h-4 text-red-700 hidden sm:block" />
        </div>
    ) : (
        /* לוגו הרשת מוסתר לפי בקשת המשתמש */
        null
    )}
</Link>
          </div>

          {/* מרכז המסך: לוגו — מעל עמודת flex-1 בימין כדי שלא תחסום קליקים לדף הבית */}
          {isStoreManager && (
            <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-center px-2">
              <Link
                to={createPageUrl("Home")}
                className="pointer-events-auto flex items-center justify-center max-w-[min(280px,78vw)]"
                aria-label="דף הבית"
              >
                <img
                  src="/keshetLogo-removebg-preview.png"
                  alt="קשת גיבורים"
                  className="h-14 w-auto sm:h-16 object-contain object-center"
                />
              </Link>
            </div>
          )}

          <div className="flex items-center gap-0 flex-1 justify-between z-10 min-w-0">
  {/* סינון קטגוריות – רק בדף קטגוריות ובדף מוצרי קטגוריה */}
  {isCategoriesOrCategoryProducts && (
    <Sheet open={isCategoryFilterOpen} onOpenChange={setIsCategoryFilterOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" title="סינון">
          <Filter className="w-5 h-5 text-gray-600" />
          {categoryFilter.activeFiltersCount > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 flex items-center justify-center rounded-full bg-red-600 text-white text-[10px] font-bold px-1">
              {categoryFilter.activeFiltersCount}
            </span>
          )}
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-[90vw] max-w-sm">
        <SheetHeader>
          <SheetTitle className="text-right">סינון מוצרים</SheetTitle>
        </SheetHeader>
        <div className="py-6 px-2">
          <div className="space-y-3">
            <div className="flex items-center gap-2 text-right">
              <Filter className="w-4 h-4 text-red-600 shrink-0" />
              <span className="font-semibold text-gray-800">סינון לפי סוג</span>
            </div>
            <div className="rounded-xl border border-gray-200 bg-white overflow-hidden divide-y divide-gray-100">
              <label className="flex items-center gap-3 p-4 cursor-pointer hover:bg-gray-50 transition-colors">
                <Checkbox id="layout-filter-returned-stock" checked={categoryFilter.showReturnedToStock} onCheckedChange={categoryFilter.setShowReturnedToStock} className="shrink-0" />
                <Package className="w-4 h-4 text-red-600 shrink-0" />
                <span className="font-medium text-gray-700 flex-1 text-right">חזר למלאי</span>
              </label>
              <label className="flex items-center gap-3 p-4 cursor-pointer hover:bg-gray-50 transition-colors">
                <Checkbox id="layout-filter-returned-assortment" checked={categoryFilter.showReturnedToAssortment} onCheckedChange={categoryFilter.setShowReturnedToAssortment} className="shrink-0" />
                <LayoutGrid className="w-4 h-4 text-violet-600 shrink-0" />
                <span className="font-medium text-gray-700 flex-1 text-right">חזר למגוון</span>
              </label>
              <label className="flex items-center gap-3 p-4 cursor-pointer hover:bg-gray-50 transition-colors">
                <Checkbox id="layout-filter-promotions" checked={categoryFilter.showPromotions} onCheckedChange={categoryFilter.setShowPromotions} className="shrink-0" />
                <Tag className="w-4 h-4 text-amber-500 shrink-0" />
                <span className="font-medium text-gray-700 flex-1 text-right">הצג מבצעים</span>
              </label>
              <label className="flex items-center gap-3 p-4 cursor-pointer hover:bg-gray-50 transition-colors">
                <Checkbox id="layout-filter-must" checked={categoryFilter.showMustOrder} onCheckedChange={categoryFilter.setShowMustOrder} className="shrink-0" />
                <AlertCircle className="w-4 h-4 text-red-500 shrink-0" />
                <span className="font-medium text-gray-700 flex-1 text-right">הצג מוצרי חובה</span>
              </label>
              <label className="flex items-center gap-3 p-4 cursor-pointer hover:bg-gray-50 transition-colors">
                <Checkbox id="layout-filter-new" checked={categoryFilter.showNew} onCheckedChange={categoryFilter.setShowNew} className="shrink-0" />
                <Sparkles className="w-4 h-4 text-blue-500 shrink-0" />
                <span className="font-medium text-gray-700 flex-1 text-right">הצג מוצרים חדשים</span>
              </label>
              <label className="flex items-center gap-3 p-4 cursor-pointer hover:bg-gray-50 transition-colors">
                <Checkbox id="layout-filter-passover" checked={categoryFilter.showPassover} onCheckedChange={categoryFilter.setShowPassover} className="shrink-0" />
                <MatzahIcon className="w-4 h-4 text-amber-600 shrink-0" />
                <span className="font-medium text-gray-700 flex-1 text-right">כשר לפסח</span>
              </label>
            </div>
          </div>

          {isCategoryProductsPage && (
            <div className="mt-6 space-y-3">
              <div className="flex items-center gap-2 text-right">
                <ArrowDownAZ className="w-4 h-4 text-red-600 shrink-0" />
                <span className="font-semibold text-gray-800">מיון תצוגה</span>
              </div>
              <p className="text-xs text-gray-500 text-right leading-snug">
                בתוך כל תת־קטגוריה / קבוצה — לפי שם בעברית (א-ב).
              </p>
              <div className="grid grid-cols-1 gap-2">
                <Button
                  type="button"
                  variant={categoryFilter.productSortMode === "default" ? "default" : "outline"}
                  className={
                    categoryFilter.productSortMode === "default"
                      ? "bg-red-600 hover:bg-red-700"
                      : ""
                  }
                  onClick={() => categoryFilter.setProductSortMode("default")}
                >
                  סדר מערכת (ברירת מחדל)
                </Button>
                <Button
                  type="button"
                  variant={categoryFilter.productSortMode === "alphabetical" ? "default" : "outline"}
                  className={
                    categoryFilter.productSortMode === "alphabetical"
                      ? "bg-red-600 hover:bg-red-700"
                      : ""
                  }
                  onClick={() => categoryFilter.setProductSortMode("alphabetical")}
                >
                  לפי א-ב (שם)
                </Button>
              </div>
            </div>
          )}

          <div className="mt-6 flex gap-2">
            <Button
              variant="outline"
              className="flex-1"
              onClick={() => {
                categoryFilter.setShowPromotions(false);
                categoryFilter.setShowMustOrder(false);
                categoryFilter.setShowNew(false);
                categoryFilter.setShowPassover(false);
                categoryFilter.setShowReturnedToStock(false);
                categoryFilter.setShowReturnedToAssortment(false);
                categoryFilter.setProductSortMode("default");
              }}
            >
              נקה הכל
            </Button>
            <Button className="flex-1 bg-red-600 hover:bg-red-700" onClick={() => setIsCategoryFilterOpen(false)}>
              סגור
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  )}

  {/* קטגוריות (Sheet) */}
  {/* <Sheet open={categoriesOpen} onOpenChange={setCategoriesOpen}>
    <SheetTrigger asChild>
      <Button variant="ghost" size="icon">
        <Grid3X3 className="w-5 h-5 text-gray-600" />
      </Button>
    </SheetTrigger>
    <SheetContent side="right" className="w-80 overflow-y-auto [&>button]:left-4 [&>button]:right-auto">
      <SheetHeader>
        <SheetTitle className="text-right">{t("allCategories")}</SheetTitle>
      </SheetHeader>

      <div className="mt-6 space-y-3">
        {mainCategories.map((mainCat) => {
          const subCats = getSubCategories(mainCat.id);
          return (
            <div key={mainCat.id} className="border rounded-lg overflow-hidden">
              <Link
                to={createPageUrl(`CategoryProducts?id=${mainCat.id}`)}
                onClick={() => setCategoriesOpen(false)}
              >
                <div className="bg-red-600 hover:bg-red-700 transition-colors p-3 flex items-center justify-between cursor-pointer">
                  <ChevronLeft className="w-4 h-4 text-white" />
                  <span className="font-bold text-white">{mainCat.name}</span>
                </div>
              </Link>

              {subCats.length > 0 && (
                <div className="p-2 bg-gray-50 space-y-1">
                  {subCats.map((subCat) => (
                    <Link
                      key={subCat.id}
                      to={createPageUrl(`CategoryProducts?id=${subCat.id}`)}
                      onClick={() => setCategoriesOpen(false)}
                    >
                      <div className="px-3 py-2 text-sm hover:bg-red-50 rounded transition-colors cursor-pointer text-right">
                        {subCat.name}
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </SheetContent>
  </Sheet> */}

  {/* סל והתראות – צמודים לצד השמאלי (ms-auto ב-RTL דוחף לשמאל) */}
  <div className="flex items-center gap-0 ms-auto">
    <Link to={createPageUrl("Notifications")}>
      <Button variant="ghost" size="icon" className="relative">
        <Bell className="w-5 h-5 text-gray-600" />
        {unreadCount > 0 && (
          <Badge className="absolute -top-1 -right-1 w-5 h-5 p-0 flex items-center justify-center bg-red-500 text-white text-xs">
            {unreadCount}
          </Badge>
        )}
      </Button>
    </Link>

    {isStoreManager && cartAccess !== 'none' && (
      <Link to={createPageUrl("Cart")}>
        <Button variant="ghost" size="icon" className="relative" data-cart-icon>
          <motion.div
            key={cartCount}
            initial={{ scale: 1 }}
            animate={{ scale: cartCount > 0 ? [1, 1.4, 1] : 1 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
          >
            <ShoppingCart className="w-5 h-5 text-gray-600" />
          </motion.div>
          {cartCount > 0 && (
            <motion.div
              key={`badge-${cartCount}`}
              initial={{ scale: 0.5, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              className="absolute -top-1 -right-1 w-5 h-5 p-0 flex items-center justify-center bg-red-600 text-white text-[10px] font-bold rounded-full shadow-sm"
            >
              {cartCount}
            </motion.div>
          )}
        </Button>
      </Link>
    )}
  </div>
  {/* התנתקות */}
  {/* <Button variant="ghost" size="icon" onClick={logout} title={t("logout")}>
    <LogOut className="w-5 h-5 text-red-500" />
  </Button> */}
</div>

        </div>
      </header>

      <div className="shrink-0 w-full" style={{ height: appHeaderHeightPx + (isImpersonating ? 40 : 0) }} aria-hidden />

      {/* Desktop Sidebar */}
      <div className="flex flex-1 overflow-hidden min-w-0 max-w-full">
        <aside
          className="hidden lg:flex flex-col w-64 bg-white border-r border-gray-100 shrink-0 z-40"
        >
          <nav className="flex-1 py-4 overflow-y-auto">
            {displayMenuItems.map((item) => {
              const url = createPageUrl(item.page);
              const isCurrentPage = location.pathname === url || location.pathname === url + "/";
              return (
                <Link
                  key={item.page}
                  to={url}
                  onClick={() => {
                    if (isCurrentPage) window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className={`flex items-center justify-start gap-3 px-6 py-3 transition-colors ${
                    isMenuItemActive(item.page)
                      ? "bg-red-50 text-red-700 border-r-4 border-red-600"
                      : "text-gray-600 hover:bg-gray-50"
                  }`}
                >
                  <item.icon className="w-5 h-5" />
                  <span className="font-medium">{item.name}</span>
                </Link>
              );
            })}
          </nav>
          <div className="p-4 border-t bg-white">
            <Button
              variant="ghost"
              className="w-full flex items-center justify-start gap-3 px-2 text-red-600 hover:bg-red-50"
              onClick={logout}
            >
              <LogOut className="w-5 h-5" />
              <span>{t("logout")}</span>
            </Button>
          </div>
        </aside>

        <main
          className="flex-1 min-w-0 overflow-y-auto overflow-x-hidden bg-gradient-to-br from-red-50 via-slate-50 to-slate-100"
        >
          {children}
        </main>
      </div>
    </div>
  );
}
